module.exports = __webpack_public_path__ + "img/banner-3.cb6f817d.png";